export default { menuItemIcon: { width: 16, height: 16 } };
